import React from 'react'

import CustomTourItemCard from './CustomTourItemCard'
import LETourItemCard from './LETourItemCard'

import { TourItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TourItem
}

export default function TourItemCard({ item }: Props) {
  // Custom items
  if (item.sourceType === 'NA') {
    return <CustomTourItemCard item={item} />
  }

  // LE Tour (TourV1 or TourV2)
  if (item.sourceType === 'LE_Tour') {
    return <LETourItemCard item={item} />
  }

  return null
}
